import * as React from 'react'
import style from './style.module.css'

let bridge: {
    setConfig?: (config: IMaskLayer) => any,
    closeMask?: () => any
} = {}
  
export function showMask(config: IMaskLayer) {
    if (bridge.setConfig) {
      bridge.setConfig({
          ...config
      })
    }
}

export function closeMask() {
    if (bridge.closeMask) {
      bridge.closeMask()
    }
}

interface IMaskLayer {
    type: string
    closeMaskFn?: () => void 
}

export function Mask() {

    const [config, setConfig] = React.useState<IMaskLayer>({type: 'close'})

    React.useEffect(() => {
        bridge.setConfig = (config) => {
            setConfig(config)
        }
        bridge.closeMask = () => {
            setConfig({type: 'close'})
        }
    }, [])

    const closeMask = React.useCallback(() => {
        setConfig({type: 'close'})
    }, [])

    if (config.type === 'open') {
        return (
            <div
            className={style['mask']}
            onClick={
              () =>
              config.closeMaskFn ? config.closeMaskFn() : closeMask()
            }
          />
        )
    } else {
        return null
    }
}


// WEBPACK FOOTER //
// ../src/popup-layer/mask-layer/index.tsx